import React, { useEffect } from "react";
import { required, useGetList } from "react-admin";
import { useForm, useFormState } from "react-final-form";
import ParentStoreSelect from "../Stores/ParentStoreSelect";
import { mapStoreOptions } from "../SimpleProducts/Products/components/productWizardConfig";
import { selectedRolesIncludeManageSimpleProducts } from "./userRoleUtils";

export const useRolesCatalog = () => {
  const { data, ids, loading } = useGetList(
    "roles",
    { page: 1, perPage: 1000 },
    { field: "id", order: "ASC" }
  );

  const allRoles = (ids || []).map((id) => data?.[id]).filter(Boolean);
  return { allRoles, loading };
};

const ManageSimpleProductsStoreField = ({ allRoles }) => {
  const form = useForm();
  const { values } = useFormState({ subscription: { values: true } });
  const hasRole = selectedRolesIncludeManageSimpleProducts(
    values.roles,
    allRoles
  );

  useEffect(() => {
    if (!hasRole && values.store_id) {
      form.change("store_id", null);
    }
  }, [form, hasRole, values.store_id]);

  if (!hasRole) return null;

  return (
    <ParentStoreSelect
      label="Store"
      transformOptions={mapStoreOptions}
      validate={required()}
    />
  );
};

export default ManageSimpleProductsStoreField;
